export default "__VITE_ASSET__2969cdc8__"